<template>
  <div id="container">
    <div class="box">
      <cont-top/>
      <cont-main/>
      <cont-bottom/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import ContOne from '@/'
import ContTop from '@/components/component/cont_top'
import ContMain from '@/components/component/productList/modCaliper/cont_main'
import ContBottom from '@/components/component/cont_bottom'
import watermark from '@/utils/waterMark'

export default {
  name: 'ModCaliper',
  comments:watermark,
  components: {
    ContTop ,
    ContMain ,
    ContBottom
  },
}
</script>

<style lang="stylus" scoped>
#container

.box
  width: 100%;
  background-color #f5f5f5

</style>
